import { PatientSummaryDto } from '../../../types/swaggerTypes'

type PatientRowAccess = Pick<
  PatientSummaryDto,
  'physicianAssociationFlag' | 'programEnrolledFlag' | 'stockOrderFlag'
>

/**
 * CLOS-14524 — a row the caller may see but must not act on or identify: the treating physician is
 * not one of theirs, or they are not enrolled on the programme. Ed Ford, 22 Sep: "if a user is not
 * associated to a treating physician then the clinical trial ID should be hidden and the primary
 * action on the status should be disabled". The same rule already blurs initials and date of birth.
 * A stock order is not held against a patient, so it is never restricted.
 */
export const isPatientRowRestrictedForCaller = (
  patient: PatientRowAccess | null | undefined
): boolean => {
  if (!patient || patient.stockOrderFlag) {
    return false
  }

  return !patient.physicianAssociationFlag || !patient.programEnrolledFlag
}
